export default "__VITE_ASSET__Dcg9l0JV__"